import { useRef, MutableRefObject } from 'react';

interface UseRefsProps<T> {
  setRef: (element: T, index: number) => void;
  getRefs: () => MutableRefObject<T[]>;
}

const useRefs = <T,>(): UseRefsProps<T> => {
  const refs = useRef<Array<T>>([]);

  const setRef = (element: T, index: number): void => {
    refs.current[index] = element;
  };

  const getRefs = (): MutableRefObject<T[]> => {
    return refs;
  };

  return { getRefs, setRef };
};

export default useRefs;
